import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { GlobalConfig, LicenseApprovalFilterModel, LOAApprovalFilterModel, SOTApprovalFilterModel, ExportFFLLiveStoreusersModel } from '../types';
import { ExportFFLLiveUserEnum } from '@/utils/constants';

interface AdminState {
  isGettingAdminConfig: boolean;
  isUpdatingSelectConfiguration: boolean;
  isSelectonfigurationUpdated: boolean;
  fflSelectConfig: GlobalConfig;
  licenseApprovalFilterModel: LicenseApprovalFilterModel;
  licenseApprovalSearchText: string;
  sotApprovalFilterModel: SOTApprovalFilterModel;
  sotApprovalSearchText: string;
  loaApprovalFilterModel: LOAApprovalFilterModel;
  loaApprovalSearchText: string;
  adminStoreFilterModel: any;
  licenseApprovalSort: string;
  sotApprovalSort: string;
  loaApprovalSort: string;
  reviewEmailTemplate:any;
  isReviewEmailTemplateLoading: boolean;
  isManualReviewEmailSendLoading: boolean;
  isCertificateStatusUpdated: boolean;
  isEmailSend: boolean;
  isShowManualReviewConfirmation: boolean;
  hideUnnecessaryRejection: boolean
  hideUnnecessarySOTRejection: boolean
  hideUnnecessaryLOARejection: boolean
  licenseReviewDetails: any;
  licenseReviewDetailsLoading: boolean;
  sotReviewDetails: any;
  sotReviewDetailsLoading: boolean;
  loaReviewDetails: any;
  loaReviewDetailsLoading: boolean;  
  exportFFLLiveStoreusersModel: ExportFFLLiveStoreusersModel;
  isExportFFLLiveUserClicked: boolean;
  isRefreshingLicenseApproval: boolean;
  isRefreshingSOTApproval: boolean;
  isRefreshingLOAApproval: boolean;
  fflStripeCustomerId: string;
}
export const defaultExportFFLLiveStoreusersModel = {
    status: ExportFFLLiveUserEnum.pending,
    filePath: "" 
}

const initialState: AdminState = {
  isGettingAdminConfig: false,
  isUpdatingSelectConfiguration: false,
  isSelectonfigurationUpdated: false,
  fflSelectConfig: {},
  licenseApprovalFilterModel: {
    status: {filterType: "set", values: ["pending"]},
    faildSteps: {filterType: "set", values: []},
    created_date_time: { filterType: "date", type: "inRange", dateFrom: "", dateTo: "" },
    source: {filterType: "set", values: []},
    searchText: { filterType: "text", type: "contains", filter: "" },
    storeType: {filterType: "set", values: ['true']},
    isManuallyRequested: {filterType: "set", values: []},
  },
  licenseApprovalSearchText: "",
  sotApprovalFilterModel: {
    status: {filterType: "set", values: ["pending"]},
    faildSteps: {filterType: "set", values: []},
    created_date_time: { filterType: "date", type: "inRange", dateFrom: "", dateTo: "" },
    source: {filterType: "set", values: []},
    searchText: { filterType: "text", type: "contains", filter: "" },
    storeType: {filterType: "set", values: ['true']},
    isManuallyRequested: {filterType: "set", values: []},
  },
  exportFFLLiveStoreusersModel: defaultExportFFLLiveStoreusersModel,
  sotApprovalSearchText: "",
  loaApprovalFilterModel: {
    status: {filterType: "set", values: ["pending"]},
    faildSteps: {filterType: "set", values: []},
    created_date_time: { filterType: "date", type: "inRange", dateFrom: "", dateTo: "" },
    source: {filterType: "set", values: []},
    searchText: { filterType: "text", type: "contains", filter: "" },
    storeType: {filterType: "set", values: ['true']},
    isManuallyRequested: {filterType: "set", values: []},
  },
  loaApprovalSearchText: "",
  adminStoreFilterModel:{
    is_external: {
        filterType: 'set', values: ['live'],
    }
},
licenseApprovalSort: 'true',
sotApprovalSort: 'true',
loaApprovalSort: 'true',
reviewEmailTemplate:{},
isReviewEmailTemplateLoading:false,
isManualReviewEmailSendLoading: false,
isCertificateStatusUpdated: false,
isEmailSend: false,
isShowManualReviewConfirmation: false,
hideUnnecessaryRejection: true,
hideUnnecessarySOTRejection: true,
hideUnnecessaryLOARejection: true,
licenseReviewDetails: {},
licenseReviewDetailsLoading: false,
sotReviewDetails: {},
sotReviewDetailsLoading: false,
loaReviewDetails: {},
loaReviewDetailsLoading: false,
isExportFFLLiveUserClicked: false,
isRefreshingLicenseApproval: false,
isRefreshingSOTApproval: false,
isRefreshingLOAApproval: false,
fflStripeCustomerId: '',

};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setIsGettingAdminConfig: (state, action: PayloadAction<boolean>) => {
      state.isGettingAdminConfig = action.payload;
    },
    setfflSelectConfig: (state, action: PayloadAction<GlobalConfig>) => {
      state.fflSelectConfig = action.payload;
    },
    setIsSelectonfigurationUpdated: (state, action: PayloadAction<boolean>) => {
      state.isSelectonfigurationUpdated = action.payload;
    },
    setIsUpdatingSelectConfiguration: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isUpdatingSelectConfiguration = action.payload;
    },
    setLicenseApprovalFilterModel: (state, action: PayloadAction<LicenseApprovalFilterModel>) => {
      state.licenseApprovalFilterModel = action.payload;
    },
    setLicenseApprovalSearchText: (state, action: PayloadAction<string>) => {
      state.licenseApprovalSearchText = action.payload;
    },
    setSOTApprovalFilterModel: (state, action: PayloadAction<SOTApprovalFilterModel>) => {
      state.sotApprovalFilterModel = action.payload;
    },
    setSOTApprovalSearchText: (state, action: PayloadAction<string>) => {
      state.sotApprovalSearchText = action.payload;
    },
    setLOAApprovalFilterModel: (state, action: PayloadAction<LOAApprovalFilterModel>) => {
      state.loaApprovalFilterModel = action.payload;
    },
    setLOAApprovalSearchText: (state, action: PayloadAction<string>) => {
      state.loaApprovalSearchText = action.payload;
    },
    setGetFFLExportLiveStoreusers: (state, action: PayloadAction<any> ) => {
      state.exportFFLLiveStoreusersModel = action.payload;
    },
    setIsExportFFLLiveUserClicked: (state, action: PayloadAction<boolean> ) => {
      state.isExportFFLLiveUserClicked = action.payload
    },
    // saga
    callToGetExportFFLLiveUsers: () =>{},
    callToGetFFLSelectConfig: () => {},
    callToUpdateSelectConfiguration: (
      state,
      action: PayloadAction<GlobalConfig>
    ) => {},
    setStoresFilterModel: (state, action: PayloadAction<any>) => {
      state.adminStoreFilterModel = action.payload;
    },
    setLicenseApprovalSort: (state, action: PayloadAction<string>) => {
      state.licenseApprovalSort = action.payload;
    },
    setSOTApprovalSort: (state, action: PayloadAction<string>) => {
      state.sotApprovalSort = action.payload;
    },
    setLOAApprovalSort: (state, action: PayloadAction<string>) => {
      state.loaApprovalSort = action.payload;
    },
    callToGetReviewEmailTemplate: (state, action: PayloadAction<any>) => {},
    setReviewEmailTemplate: (state, action: PayloadAction<any>) => {
      state.reviewEmailTemplate = action.payload;
    },
    setIsReviewEmailTemplateLoading: (state, action: PayloadAction<boolean>) => {
      state.isReviewEmailTemplateLoading = action.payload;
    },
    setIsManualReviewEmailSendLoading: (state, action: PayloadAction<boolean>) => {
      state.isManualReviewEmailSendLoading = action.payload;
    },
    callToSendReviewEmailTemplate: (state, action: PayloadAction<any>) => {},
    setIsCertificateStatusUpdated: (state, action: PayloadAction<boolean>) => {
      state.isCertificateStatusUpdated = action.payload;
    },
    setIsEmailSend: (state, action: PayloadAction<boolean>) => {
      state.isEmailSend = action.payload;
    },
    setIsShowManualReviewConfirmation: (state, action: PayloadAction<boolean>) => {
      state.isShowManualReviewConfirmation = action.payload;
    },
    setHideUnnecessaryRejection: (state, action: PayloadAction<boolean>) => {
      state.hideUnnecessaryRejection = action.payload;
    },
    setHideUnnecessarySOTRejection: (state, action: PayloadAction<boolean>) => {
      state.hideUnnecessarySOTRejection = action.payload;
    },
    setHideUnnecessaryLOARejection: (state, action: PayloadAction<boolean>) => {
      state.hideUnnecessaryLOARejection = action.payload;
    },
    callToGetLicenseReviewDetails: (state, action: PayloadAction<any>) => {},
    setLicenseReviewDetails: (state, action: PayloadAction<any>) => {
      state.licenseReviewDetails = action.payload;
    },
    setLicenseReviewDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.licenseReviewDetailsLoading = action.payload;
    },
    callToGetSOTReviewDetails: (state, action: PayloadAction<any>) => {},
    setSOTReviewDetails: (state, action: PayloadAction<any>) => {
      state.sotReviewDetails = action.payload;
    },
    setSOTReviewDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.sotReviewDetailsLoading = action.payload;
    },
    callToGetLOAReviewDetails: (state, action: PayloadAction<any>) => {},
    setLOAReviewDetails: (state, action: PayloadAction<any>) => {
      state.loaReviewDetails = action.payload;
    },
    setLOAReviewDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.loaReviewDetailsLoading = action.payload;
    },
    setIsRefreshingLicenseApproval: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingLicenseApproval = action.payload;
    },
    setIsRefreshingSOTApproval: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingSOTApproval = action.payload;
    },
    setIsRefreshingLOAApproval: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingLOAApproval = action.payload;
    },
    setFFLStripeCustomerId: (state, action: PayloadAction<string>) => {
      state.fflStripeCustomerId = action.payload;
    },
  } 
});

export const {
  setIsGettingAdminConfig,
  setfflSelectConfig,
  setIsUpdatingSelectConfiguration,
  setIsSelectonfigurationUpdated,
  setLicenseApprovalFilterModel,
  setLicenseApprovalSearchText,
  setSOTApprovalFilterModel,
  setSOTApprovalSearchText,
  setLOAApprovalFilterModel,
  setLOAApprovalSearchText,
  // saga
  callToGetFFLSelectConfig,
  callToUpdateSelectConfiguration,
  setStoresFilterModel,
  setLicenseApprovalSort,
  setSOTApprovalSort,
  setLOAApprovalSort,
  callToGetReviewEmailTemplate,
  setReviewEmailTemplate,
  setIsReviewEmailTemplateLoading,
  setIsManualReviewEmailSendLoading,
  callToSendReviewEmailTemplate,
  setIsCertificateStatusUpdated,
  setIsEmailSend,
  setIsShowManualReviewConfirmation,
  setHideUnnecessaryRejection,
  setHideUnnecessarySOTRejection,
  setHideUnnecessaryLOARejection,
  callToGetLicenseReviewDetails,
  setLicenseReviewDetailsLoading,
  setLicenseReviewDetails,
  callToGetSOTReviewDetails,
  setSOTReviewDetails,
  setSOTReviewDetailsLoading,
  callToGetLOAReviewDetails,
  setLOAReviewDetails,
  setLOAReviewDetailsLoading,
  setGetFFLExportLiveStoreusers,
  callToGetExportFFLLiveUsers,
  setIsExportFFLLiveUserClicked,
  setIsRefreshingLicenseApproval,
  setIsRefreshingSOTApproval,
  setIsRefreshingLOAApproval,
  setFFLStripeCustomerId,
} = adminSlice.actions;

export default adminSlice.reducer;
